export default {"src":"/_next/static/media/Typing-bubble-left.364b4837.gif","height":40,"width":75,"blurWidth":0,"blurHeight":0};